import { createSlice } from '@reduxjs/toolkit';

const initState = {
  filterUserDashboad: {
    roles: [],
    business_access: [],
    date: {},
  },
};

const userAccessManagementSlice = createSlice({
  name: 'userAccessManagement',
  initialState: initState,
  reducers: {
    updateFilterUserDashboadText: (state, action) => {
      state.filterUserDashboad = action.payload;
    },
  },
});
const { actions, reducer: userAccessManagementReducer } = userAccessManagementSlice;
export const { updateFilterUserDashboadText } = actions;
export default userAccessManagementReducer;
